const motiveTypes = {
  SUPPORT_REQUEST: 'Solicitud de apoyo docente',
  DISCRIMINATION_SITUATION: 'Situación de discriminación',
  INTERVIEW_REQUEST: 'Solicitud de entrevista con equipo de educación',
  ACCOMPANIMENT_REQUEST: 'Solicitud de acompañamiento del proceso educativo',
  OTHER: 'Otro',
};

export default motiveTypes;
